module.exports = __webpack_public_path__ + "img/11.a2a3c880.svg";